import { Component, DataSource, DataSourceRemoteDataChangeEvent, PanelProps, Tab } from "@mcleod/components";
import { LMEUserSettings } from "@mcleod/general";
import { MultiProfilePlanningTabs } from "@mcleod/dispatch/src/planning/MultiProfilePlanningTabs";
import { AutogenLayoutBrokeragePlanningMultiProfile } from "./autogen/AutogenLayoutBrokeragePlanningMultiProfile";
import { BrokeragePlanning } from "./BrokeragePlanning";

export class BrokeragePlanningMultiProfile extends AutogenLayoutBrokeragePlanningMultiProfile {
    private userProfiles: string[] = [];

    async onLoad(): Promise<void> {
        if (LMEUserSettings.get()?.bp_profile != null)
            this.userProfiles.push(LMEUserSettings.get().bp_profile);
        if (LMEUserSettings.get()?.bp_profile2 != null)
            this.userProfiles.push(LMEUserSettings.get().bp_profile2);
        if (LMEUserSettings.get()?.bp_profile3 != null)
            this.userProfiles.push(LMEUserSettings.get().bp_profile3);
        if (LMEUserSettings.get()?.bp_profile4 != null)
            this.userProfiles.push(LMEUserSettings.get().bp_profile4);

        new MultiProfilePlanningTabs({
            tabset: this.tabsetBrokeragePlanningProfiles,
            profileDataSource: this.sourceBrokeragePlanningProfile,
            mainLayoutName: "lme/powerbroker/BrokeragePlanning",
            advancedFilterLayout: "lme/powerbroker/BrokeragePlanningProfileFilter",
            startingProfiles: this.userProfiles,
            profileDescrFieldName: "title",
            dataSourceToAddListener: this.sourceBrokerageMovements
        });
    }


    handleRemoteDataChange(event: DataSourceRemoteDataChangeEvent) {
        event.preventDefault();
        this.tabsetBrokeragePlanningProfiles.components.forEach((tab: Tab, index) => {
            tab.components.forEach((component: Component) => {
                if (component instanceof BrokeragePlanning) {
                    if ("lme/powerbroker/brokerage-movements" === (event.target as DataSource).url) {
                        const dataSource = component.sourceBrokerageMovements
                        dataSource.handleDataChange(event.change);
                    }
                }
            })
        })
    }

    // Override the main router's padding to get the vertical profile tabset to be flush with the edge of the screen
    getRouterProps(): Partial<PanelProps> {
        return { padding: 0 };
    }
}
